import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { delay, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";
import { succesngonit } from "./cotizador/datos-seguro-propietario/oginit";
import { successummit, successummitBitacora, successummitMasdedosPolizas,successummitMasdedosPolizasBitacora } from "./cotizador/datos-seguro-inquilino/summitsuccess";
import { leadduplicados, NoDuplicateLead, NoDuplicateLeadAsesorCode } from "./cotizador/datos-seguro-propietario/summit";
import { inactividad } from "./cotizador/datos-seguro-inquilino/inactividad";
import { nosuscribeconposibilidadBitacora, usocomercialcomercial, usoresidencialsuccess, usoresidencialsuccessBitacora } from "./cotizador/datos-propiedad/sumit";
import { succesngonitplanes } from "./cotizador/planes/onginit";
import { summitexitoso } from "./cotizador/planes/summit";
import { consultaRiesgoInquilinoNoPasa, consultaRiesgoPasa, consultaRiesgoPropietarioNoPasa, summitexitosoconmasdenpolizas, summitexitososinnpolizas } from "./cotizador/propietario-complementario/summit";
import { successummitnewdatosinquilino } from "./cotizador/new-datos-propietario/new-datos-propietario";

export class CotizadorInterceptor implements HttpInterceptor {
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
 
        if (req.url.endsWith(environment.URL_MULESOFT_ORQUESTADOR)) {
            

            if (req.body && req.body.getInitialData) { 
                
                console.log('entra en el interceptor cotizador propietario init pantalla 1');
                return of(new HttpResponse({ status: 200, body: succesngonit })).pipe(delay(3000));
           
             }
            if (req.body  && req.body.getLeadDuplicated) { // PANTALLA P1 PROPIETARIO 
                
                console.log('entra en el interceptor de de propietario en el summit pantalla 1');
                return of(new HttpResponse({ status: 200, body: NoDuplicateLeadAsesorCode })).pipe(delay(3000));
           
            }
            if (req.body && req.body.getTenantPolicies) { // para pantallas de datos inquilino  p2
                
                 console.log('entra en el interceptor de inquilino getTenantPolicies');
                return of(new HttpResponse({ status: 200, body: successummitBitacora })).pipe(delay(3000));
            
                  }
            if (req.body && req.body.getScore) { // pantalla propiedad p3 si tiene menos de 5 millones y es residencial
                
                    console.log('entra en el interceptor de inquilino');
                     return of(new HttpResponse({ status: 200, body: usoresidencialsuccessBitacora })).pipe(delay(3000));
               
            }
            if (req.body && req.body.leadRequirement) { // pantalla propiedad p3 si tiene mas de 5 millones o es comerccial
                
                console.log('entra en el interceptor de inquilino');
                return of(new HttpResponse({ status: 200, body: usocomercialcomercial })).pipe(delay(3000));
         }

        if (req.body && req.body.screenPercentage == '45') { // pantalla de nuevo contrato el exito la respuesta es la misma siu es de uso comercial en la pantalla 3
            
            return of(new HttpResponse({ status: 200, body: usocomercialcomercial })).pipe(delay(3000));
        }


        //  pantalla 5 planes de seguros
        if (req.body && req.body.getPriceData) {
            
            console.log('entra en el interceptor cotizador propietario init');
            return of(new HttpResponse({ status: 200, body: succesngonitplanes })).pipe(delay(3000));
        }

        if (req.body && req.body.getOwnerPolicies) { // pantalla de complementario propietario
            
            console.log('entra en el interceptor cotizador summt propietario complementario');
            return of(new HttpResponse({ status: 200, body: summitexitososinnpolizas })).pipe(delay(3000));
        }

        if (req.body && req.body.getRiesgos) {
            
            console.log('entra en el interceptor cotizador getRiesgos');
            return of(new HttpResponse({ status: 200, body: consultaRiesgoPasa })).pipe(delay(3000));
        }

        if (req.body && req.body.createQuote) {
            
            console.log('entra en el interceptor cotizador createQuote');
            return of(new HttpResponse({ status: 200, body: successummitnewdatosinquilino })).pipe(delay(3000));
        }

        if (req.body && req.body.productsConfigurationData.ProductCode) {
            
            console.log('entra en el interceptor cotizador propietario init');
            return of(new HttpResponse({ status: 200, body: summitexitoso })).pipe(delay(3000));
        }

           

          
   

     if (req.body && req.body.screenPercentage) {
        console.log('entra en el interceptor cotizador propietario init');
        return of(new HttpResponse({ status: 200, body: inactividad })).pipe(delay(3000));
    }
            
            return of(new HttpResponse({ status: 200, body: succesngonit })).pipe(delay(3000));
        }
        return next.handle(req);
    }

}